import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ComponentBase, PriceModel } from 't4core';


@Component({
    selector: 't4-priceInfo',
    templateUrl: './priceInfo.html',
    styleUrls: ['./priceInfo.css'],
})
export class T4PriceInfo extends ComponentBase implements OnInit {
    @Input() public price: PriceModel;
    @ViewChild("base", {static: false}) public base: ElementRef;
    @ViewChild("floater", {static: false}) public tooltip: ElementRef;
   
    constructor(private route: Router, private activeRoute: ActivatedRoute) {
        super();
    }

    public ngOnInit() {
       
    }


    public show(event) {
        this.UI.float(this.tooltip.nativeElement, event.clientX - event.offsetX, null, null, event.clientY - event.offsetY);
    }

    public hide() {
        setTimeout(() => {
            this.UI.drop(this.tooltip.nativeElement);
        }, 100);
    }
}
